module.exports = __webpack_public_path__ + "img/ep7-6c.e3dee526.png";